/**
 * v-truncate-tooltip
 * 仅当元素被父容器截断时显示 MDB Tooltip。
 *
 * 父容器要求：
 *   - 块级元素
 *   - 设置了 overflow: hidden + white-space: nowrap（用 .text-ellipsis 类即可）
 *   - 有明确宽度约束（固定宽度 / flex item / table 列等）
 *
 * 用法：
 *   <div class="text-ellipsis" style="max-width: 200px">
 *     <span v-truncate-tooltip>{{ longText }}</span>
 *   </div>
 *
 * 依赖：window.mdb.Tooltip 必须已加载
 */
const TOOLTIP_OPTIONS = { placement: 'top', customClass: 'tooltip-name', container: 'body' }

export const vTruncateTooltip = {
  mounted(el) {
    const update = () => {
      const Tooltip = window.mdb?.Tooltip
      if (!Tooltip) return
      const box = el.parentNode
      if (!box) return
      const text = el.dataset.tooltipText || el.textContent || ''
      const truncated = !!text.trim() && box.scrollWidth > box.clientWidth
      const inst = Tooltip.getInstance(box)
      const currentTitle = box.getAttribute('title') || box.getAttribute('data-mdb-original-title')
      if (truncated && currentTitle !== text) {
        inst?.dispose()
        box.removeAttribute('data-mdb-original-title')
        box.setAttribute('title', text)
        new Tooltip(box, TOOLTIP_OPTIONS)
      } else if (!truncated && inst) {
        inst.dispose()
        box.removeAttribute('title')
        box.removeAttribute('data-mdb-original-title')
      }
    }
    el._tt = update
    const ro = new ResizeObserver(update)
    ro.observe(el.parentNode)
    el._ttCleanup = () => {
      ro.disconnect()
      window.mdb?.Tooltip?.getInstance(el.parentNode)?.dispose()
    }
  },
  updated(el) { el._tt?.() },
  unmounted(el) { el._ttCleanup?.() }
}

export default {
  install(app) {
    app.directive('truncate-tooltip', vTruncateTooltip)
  }
}
